import './Industries.css';

const industries = [
  'Retail & Fashion',
  'Clinics & Healthcare',
  'Education & Coaching',
  'Restaurants & Food Brands',
  'Real Estate',
  'Jewellery & Boutiques',
  'Manufacturing & B2B',
  'Salons & Wellness',
  'Home Services',
  'Startups & D2C',
];

export default function Industries() {
  return (
    <section id="industries" className="ind-section">
      <div className="ind-header">
        <span className="section-label reveal">Industries</span>
        <h2 className="section-title reveal">Every business type, <em>covered.</em></h2>
        <p className="section-sub reveal">
          From Trichy shops to Tamil Nadu-wide brands — we've built websites and campaigns across these industries.
        </p>
      </div>
      <div className="ind-tags reveal stagger">
        {industries.map(name => (
          <span key={name} className="ind-tag">{name}</span>
        ))}
      </div>
    </section>
  );
}
